import { Option } from "@circle-react-shared/uikit/Combobox/Option";
import { Options } from "@circle-react-shared/uikit/Combobox/Options";
import { OptionsScrollableContainer } from "@circle-react-shared/uikit/Combobox/OptionsScrollableContainer";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { CreatableOption } from "@circle-react/components/QuickPostV2/Content/TopicsPicker/CreatableOption";
import { LoadingStateOption } from "@circle-react/components/QuickPostV2/Content/TopicsPicker/LoadingStateOption";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Topic } from "@circle-react/types/Topic";
import { truncate } from "lodash";
import type { CSSProperties, RefObject } from "react";

import { t } from "@/i18n-js/instance";

interface DropdownOptionsProps {
  attributes?: { [key: string]: string };
  isCreatingTopic: boolean;
  isLoading: boolean;
  onCreateTopic: (topicName: string) => void;
  popperRef: RefObject<HTMLDivElement | null>;
  searchQuery: string;
  shouldShowCreateTopic: boolean;
  shouldShowDropdown: boolean;
  style: CSSProperties;
  topics: Topic[];
}

export const DropdownOptions = ({
  searchQuery,
  topics,
  isLoading,
  isCreatingTopic,
  onCreateTopic,
  shouldShowCreateTopic,
  shouldShowDropdown,
  style,
  attributes,
  popperRef,
}: DropdownOptionsProps) => (
  <div
    className={classNames("z-10 max-w-[min(90vw,288px)]", {
      invisible: !shouldShowDropdown,
    })}
    ref={popperRef}
    style={style}
    {...attributes}
  >
    <Options className="!relative" dataTestId="topics-dropdown-list">
      <OptionsScrollableContainer>
        {isLoading && <LoadingStateOption />}
        {topics.map(topic => (
          <Option option={topic} key={topic.id}>
            <div className="flex items-center justify-between">
              <Typography.LabelSm>
                {truncate(topic.name, {
                  length: 25,
                })}
              </Typography.LabelSm>
              {topic.admin_only && (
                <Typography.LabelXs color="text-light">
                  {t("quick_post_v2.topics.admin_only")}
                </Typography.LabelXs>
              )}
            </div>
          </Option>
        ))}
        {shouldShowCreateTopic && (
          <CreatableOption
            isCreatingTopic={isCreatingTopic}
            onCreateTopic={onCreateTopic}
            searchQuery={searchQuery}
          />
        )}
      </OptionsScrollableContainer>
    </Options>
  </div>
);
